<template>
    <div>
        <portal-target v-for="name of modalPortalNames" :key="name" :name="name" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import bus from "@/bus";
import { ModalActions } from "@/enums/ui";

export default defineComponent({
    data() {
        return {
            modalPortalNames: [] as string[]
        };
    },
    beforeUnmount() {
        bus.$off(ModalActions.AddModalPortal, this.addModalPortal);
        bus.$off(ModalActions.RemoveModalPortal, this.removeModalPortal);
    },
    created() {
        bus.$on(ModalActions.AddModalPortal, this.addModalPortal);
        bus.$on(ModalActions.RemoveModalPortal, this.removeModalPortal);
    },
    methods: {
        addModalPortal(newModalPortalName: string) {
            this.modalPortalNames = [...this.modalPortalNames, newModalPortalName];
        },
        removeModalPortal(modalPortalName: string) {
            this.modalPortalNames = this.modalPortalNames.filter(name => name !== modalPortalName);
        }
    }
});
</script>

<style module lang="scss"></style>
